import $ from 'jquery';
import formatCurrency, { getDecimalSeparator } from '~shared/utils/currencyUtils';
import { pushToDataLayer } from '~shared/utils/google-tag-manager.js';
import {
    GTM_BETSLIP,
    GTM_BABY_BETSLIP,
    GTM_STAKE_AREA,
    GTM_STAKE_AREA_EVENT,
    GTM_EVENT_PUNCTUATION,
    GTM_EVENT_QUICK_STAKE,
    GTM_EVENT_DELETE,
    GTM_EVENT_CONFIRM
} from '~legacy/modules/jsx/betslip/constants.js';

const AbstractKeyboard = function (options) {
    if (this.constructor === AbstractKeyboard) {
        throw new Error('Cannot instanciate abstract class');
    }
    var defaults = {
        beamIndicator: '|',
        freebetSelector: '#betslip-fancy-keyboard__freebet',
        viewSelector: '#fancy-keyboard',
        isMobile: true,
    };
    if (typeof options === 'undefined') {
        options = {};
    }

    this.options = Object.assign(defaults, options);
    //define platform when construct the keyboard
    this.isMobile = this.options.isMobile;
};

AbstractKeyboard.prototype = {
    isVisible: false,
    boundToElement: null,
    boundElementType: null,
    stakeLabel: null,
    keyboardView: null,
    freebetModule: null,
    freeBetModuleVisible: false,
    animationSpeed: 'fast',
    target: '',

    //here be initialization for physical keypresses
    fkInitPhyKeyHandlers: function InitPhysicalKeyboardKeypressHandler() {
        var self = this;
        $(document).on("keydown keypress", function (keypressEvent) {
            /**
             * If keypress belongs to a form with data-override-bs-keyboard="1"
             * the keypress is ignored and allowed to propagate
             */
            var grabKeyEvent = true;
            if (keypressEvent.target.tagName === 'INPUT') {
                grabKeyEvent = false;
            }

            //we check if the keyboard is out and if its binded to an actual eligible element
            if (grabKeyEvent && self.isVisible && self.boundToElement) {
                //now we halt the normal behavior of the keypresses
                keypressEvent.preventDefault();
                keypressEvent.stopPropagation();

                //and prepare a value that we'll use to store the fkbutton we want to simulate tapping
                var desiredButtonValue = null;

                //here we discriminate the keycode of the key pressed
                //the double codes are for handle the numpad number also
                switch (keypressEvent.which) {
                    case 8:
                        //backspace
                        desiredButtonValue = 'action-back';
                        break;
                    case 190:
                    case 110:
                    case 188:
                        // .
                        desiredButtonValue = 'sign-dot';
                        break;
                    case 48:
                    case 96:
                        //0
                        desiredButtonValue = '0';
                        break;
                    case 49:
                    case 97:
                        //1
                        desiredButtonValue = '1';
                        break;
                    case 50:
                    case 98:
                        //2
                        desiredButtonValue = '2';
                        break;
                    case 51:
                    case 99:
                        //3
                        desiredButtonValue = '3';
                        break;
                    case 52:
                    case 100:
                        //4
                        desiredButtonValue = '4';
                        break;
                    case 53:
                    case 101:
                        //5
                        desiredButtonValue = '5';
                        break;
                    case 54:
                    case 102:
                        //6
                        desiredButtonValue = '6';
                        break;
                    case 55:
                    case 103:
                        //7
                        desiredButtonValue = '7';
                        break;
                    case 56:
                    case 104:
                        //8
                        desiredButtonValue = '8';
                        break;
                    case 57:
                    case 105:
                        //9
                        desiredButtonValue = '9';
                        break;
                    case 13:
                        //return
                        desiredButtonValue = 'action-done';
                        break;
                    default:
                        break;
                }

                //finally we simulate the click on the fkbutton
                if (desiredButtonValue) {
                    self.fkButtonTapped(self.keyboardView.find('div[data-btnvalue="' + desiredButtonValue + '"]'), false, true);
                }
            }
        });
    },

    /**
     * adds gtm for keypad presses 
     * 
     * @param {string} input - button element clicked on for gtm
     * @param {boolean} isBabyBetslip - click from keyboard on baby-betslip
     * @param {boolean} isDesktopKeyboard - true if click from physical keyboard on your desk. Used in InitPhysicalKeyboardKeypressHandler()
     */
    creatGtmForKeyboard: function(input, isBabyBetslip, isDesktopKeyboard) {
        const gtmBetslipType = !isBabyBetslip ? GTM_BETSLIP : GTM_BABY_BETSLIP;

        if (!isDesktopKeyboard) {
            pushToDataLayer({
                event: GTM_STAKE_AREA_EVENT, 
                parameter:`${gtmBetslipType};${GTM_STAKE_AREA};${input}`,
                ecommerce: undefined,
            });
        }
    },


    /**
     * fkButtonTapped - handles user clicks on keyboard
     * 
     * @param {object} FKbutton - button element clicked on
     * @param {boolean} isBabyBetslip - click from keyboard on baby-betslip
     * @param {boolean} isDesktopKeyboard - true if click from physical keyboard on your desk. Used in InitPhysicalKeyboardKeypressHandler()
     **/
    fkButtonTapped: function (FKbutton, isBabyBetslip = false, isDesktopKeyboard = false) {
        var buttonValue = FKbutton.data('btnvalue');

        const incrementValue = parseInt(FKbutton.data('increment'));

        if(!isNaN(incrementValue) && !isDesktopKeyboard) {
            this.fkIncrementValue(buttonValue);
            this.creatGtmForKeyboard(`${GTM_EVENT_QUICK_STAKE}-${buttonValue}`, isBabyBetslip, isDesktopKeyboard);
        }
        // user tapped a 0
        else if (parseInt(buttonValue) === 0) {
            //valid zero tapped
            if (this.userInput !== '') {
                this.fkConcatValue(buttonValue);
                this.creatGtmForKeyboard(buttonValue, isBabyBetslip, isDesktopKeyboard);
            }
        } else if (parseInt(buttonValue)) {
            //user tapped a number
            this.fkConcatValue(buttonValue);
            this.creatGtmForKeyboard(buttonValue, isBabyBetslip, isDesktopKeyboard);
        } else if (String(buttonValue).indexOf('qa-') != -1) {
            //user tapped a quick amount button
            var quickAmountValue = buttonValue.substr(3, 5);
            this.fkReplaceValue(quickAmountValue);
        } else if (buttonValue === 'sign-dot') {
            //user tapped the dot sign
            this.creatGtmForKeyboard(GTM_EVENT_PUNCTUATION, isBabyBetslip, isDesktopKeyboard);
            if (this.userInput.indexOf(getDecimalSeparator()) === -1) {
                //if we have no dot in the userinput we allow to place the decimal sign
                this.fkConcatValue(getDecimalSeparator());
            }
        } else if (buttonValue === 'action-back') {
            //user tapped the back button
            this.creatGtmForKeyboard(GTM_EVENT_DELETE, isBabyBetslip, isDesktopKeyboard);
            if (this.userInput.length > 0) {
                //userInput not empty so we allow the delete action
                this.fkPopLastValue();
            }
        } else if (buttonValue === 'action-done') {
            //user tapped the done button
            this.fkDoneButtonTapped();
            this.creatGtmForKeyboard(GTM_EVENT_CONFIRM, isBabyBetslip, isDesktopKeyboard);
        }
    },

    // increment
    fkIncrementValue: function (value) {
        let currentInputValue = this.userInput.replace(',', '.').replace(' ', '');
        if (isNaN(currentInputValue)) {
            currentInputValue = 0;
        }
        this.userInput = formatCurrency(
            String((Number(currentInputValue) + Number(value)).toFixed(2)),
            null,
            null,
            false,
            false,
            2);
        this.fkUpdateNumericalStakeValue();
    },

    // concatenates a string to the userInput
    fkConcatValue: function (value) {
        // if stake has already 2 numbers in decimal places, then clear stake
        const delimiter = this.userInput.includes('.') ? '.' : ',';
        const [, decimal] = this.userInput.split(delimiter);
        const numberOfDecimalDigits = decimal ? decimal.length : 0;
        if (numberOfDecimalDigits >= 2) {
            this.userInput = value;
            this.fkReplaceValue(this.userInput);
        } else {
            this.userInput += String(value);
            this.fkUpdateNumericalStakeValue();
        }
    },


    // replaces the userInput value with the given one
    fkReplaceValue: function (value) {
        this.userInput = String(value);
        this.fkUpdateNumericalStakeValue();
    },

    // removes the last chatacter from the userInput
    fkPopLastValue: function () {
        this.userInput = this.userInput.slice(0, -1);
        this.fkUpdateNumericalStakeValue();
    },

};

export default AbstractKeyboard;
